import { useState } from "react";

export default function AboutUsPage () {

    const [isOpenJustin, setIsOpenJustin] = useState(false);
    const [isOpenAnthony, setIsOpenAnthony] = useState(false);
    const [isOpenChris, setIsOpenChris] = useState(false);

    return(
        <div className="flex justify-center min-h-screen">
            <div className="text-center max-w-2xl p-6">
                <h1 className="text-3xl font-bold text-center my-6">About us</h1>
                <p className="text-base text-black mb-6">
                Welcome to the parish of Our Lady, Queen of Martyrs & St Swithin, serving Christ in the heart of the community of Croxteth. 
                We are a welcoming, vibrant and diverse community, celebrating the love of the Lord in our lives, and doing our best to extend 
                that love to our brothers and sisters within the local community.
                </p>
                <p className="text-base text-black mb-6">
                The parish of Our Lady, Queen of Martyrs, was first established in 1963, and in 2004 amalgamated with the parish of nearby St Swithin.
                The parish of St Swithin has a rich Catholic history and was first recorded as a Mass Centre in 1425.
                </p>
                <p className="text-base text-black mb-6">
                We hope you find what you are looking for on our website, and please be assured of a warm welcome if you wish to pay us a visit – 
                we would be delighted to see you!
                </p>
                <p className="text-base text-black mb-6">
                Yours in Christ,
                Fr Anthony Kelly
                Parish priest
                </p>
            <div className="mt-6">
                <h1 className="text-3xl font-bold text-center">Meet the team:</h1>
                {/* Meet the team for Anthony Kelly*/}
                <div className="py-6 px-6 md:px-12 lg:px-24 flex justify-center">
                    <div className="w-full max-w-screen-lg bg-white p-8 rounded-2xl shadow-lg">
                        <div className="flex items-center mb-6">
                        <img
                            src="/pictures/fr_kelly.jpg"
                            alt="User"
                            className="w-16 h-16 rounded-full border-4 border-blue-500"
                        />
                        <div className="ml-4">
                            <h3 className="text-lg font-semibold text-blue-700">Rev. Fr Anthony Kelly</h3>
                        </div>
                        </div>
                        <button
                        onClick={() => setIsOpenAnthony(!isOpenAnthony)}
                        className="w-full text-left bg-blue-500 text-white px-4 py-2 rounded-md focus:outline-none"
                        >
                        {isOpenAnthony ? "Hide About me" : "Read About me"}
                        </button>
                        {isOpenAnthony && (
                            <p className="text-gray-700 italic mt-4">
                                I was ordained a priest in 2018 and have been at OLQM & SS since September 2019, initially as Assistant Priest, 
                                and then more recently as Parish Priest. Prior to my studies for Priesthood, I was a Civil Servant for 7 years 
                                before completing a PGCE and teaching in both Primary and Secondary Education. I am originally from Wigan where 
                                some of my family still reside. As far as interests go, I am very sport-oriented but as life progresses, I can 
                                equally appreciate a good book or film, accompanied by an equally good coffee!
                            </p>
                        )}
                    </div>
                </div>
                {/* Meet the team for Chris Housbey*/}
                <div className="py-12 px-6 md:px-12 lg:px-24 flex justify-center">
                    <div className="w-full max-w-screen-lg bg-white p-8 rounded-2xl shadow-lg">
                        <div className="flex items-center mb-6">
                        <img
                            src="/pictures/jhp_chris_01.jpg"
                            alt="User"
                            className="w-16 h-16 rounded-full border-4 border-blue-500"
                        />
                        <div className="ml-4">
                            <h3 className="text-lg font-semibold text-blue-700">Rev. Dcn Chris Housbey </h3>
                        </div>
                        </div>
                        <button
                        onClick={() => setIsOpenChris(!isOpenChris)}
                        className="w-full text-left bg-blue-500 text-white px-4 py-2 rounded-md focus:outline-none"
                        >
                        {isOpenChris ? "Hide About me" : "Read About me"}
                        </button>
                        {isOpenChris && (
                            <p className="text-gray-700 italic mt-4">
                                I was born in All Saints Parish in Anfield and was an Altar Server from the age of 8. I discerned a 
                                vocation to the priesthood and spent 6 years at Upholland and 2 years at Ushaw. This didn’t work out 
                                and I married Catherine in 1994, and we have 3 daughters, Caitlin, Erin and Niamh. I started training
                                for the Diaconate in 2014 and was ordained in 2018. I feel that it is an amazing privilege to serve in
                                Our Lady Queen of Martyrs & St Swithin’s and really enjoy our vibrant Parish Liturgies and events and 
                                visiting our local Church and non-Church Schools.
                            </p>
                        )}
                    </div>
                </div>
                {/* Meet the team for Justin Malawezi*/}
                <div className="py-12 px-6 md:px-12 lg:px-24 flex justify-center">
                    <div className="w-full max-w-screen-lg bg-white p-8 rounded-2xl shadow-lg">
                        <div className="flex items-center mb-6">
                        <img
                            src="/pictures/jm_about_me.png"
                            alt="User"
                            className="w-16 h-16 rounded-full border-4 border-blue-500"
                        />
                        <div className="ml-4">
                            <h3 className="text-lg font-semibold text-blue-700">Rev. Dcn. Justin Malewezi Jnr.</h3>
                            <p className="text-gray-500">FHEA Fellow, MRes, QTS, BA Hon, Cert PM</p>
                            <p className="text-gray-500">j.malewezi@rcaol.org.uk</p>
                        </div>
                        </div>
                        <button
                        onClick={() => setIsOpenJustin(!isOpenJustin)}
                        className="w-full text-left bg-blue-500 text-white px-4 py-2 rounded-md focus:outline-none"
                        >
                        {isOpenJustin ? "Hide About me" : "Read About me"}
                        </button>
                        {isOpenJustin && (
                            <>
                            <p className="text-gray-700 italic mt-4">
                                My name is Rev. Justin Malewezi Jnr. The word “Malewezi” means zebra stripes in Chichewa language. 
                                I was born and raised in Malawi, Africa. I am passionate about helping people reach their God-given 
                                potential, and supporting them with food, shelter, education, and faith. From a young age, my father,
                                the late Rt. Hon. Canon Justin Malewezi, helped me to understand that as a community, we need to look 
                                after each other and that every person in our society is valuable and should be respected.
                            </p>
                            <p className="text-gray-700 italic mt-4">
                                After several years working for the United Nations agencies in Malawi, I taught in a primary, secondary 
                                school and college in England. Then I became a university lecturer and researcher. I have worked in the field 
                                of education since 2004.
                            </p>
                            <p className="text-gray-700 italic mt-4">
                                I was ordained a Permanent Deacon in the Catholic Church on 16th July 2023 in Liverpool. My vision is to help in 
                                building communities are centred on the love and works of God.
                            </p>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
        </div>
    );
}